// src/pages/ProductDetailPage.jsx

import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import {
  FaStar,
  FaStarHalfAlt,
  FaRegStar,
  FaArrowLeft,
  FaMapMarkerAlt,
  FaPhone,
  FaStore,
  FaCalendarAlt,
} from "react-icons/fa";
import MyNavbar from "../../../../components/user/general/mynavbar/MyNavbar.js";
import Footer from "../../../../components/user/general/footer/Footer.js";
import EquipmentBookingModal from "../../../../subscreens/users/shop/bookingform/BookingForm.js";
import "../../../../assets/css/user/shoppage/productdetailpage/ProductDetailPage.css";
import axios from "axios";
import Swal from "sweetalert2";
import AppContext from "../../../../context/AppContext.js";

const ProductDetailPage = () => {
  const { state } = useLocation();
  const { baseUrl, baseUrlForFile } = useContext(AppContext);
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [product, setProduct] = useState();

  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const shopId = location.state?.shopId;
  const equipment = state?.equipment;

  const shop = {
    id: shopId || product?.srrentaladmin_id || 1,
    name: product?.shop_name || "Unknown Shop",
    location: product?.shop_address || "—",
    phone: "03000000000",
  };

  // ── Helper: teeno rates me se filled wale nikalna ──
  const getAvailableRates = (p) => {
    if (!p) return [];
    const rates = [];
    if (p.rate_per_hour) rates.push({ label: "Per Hour", value: Number(p.rate_per_hour), unit: "hour" });
    if (p.rate_per_day) rates.push({ label: "Per Day", value: Number(p.rate_per_day), unit: "day" });
    if (p.rate_per_acre) rates.push({ label: "Per Acre", value: Number(p.rate_per_acre), unit: "acre" });
    return rates;
  };

  // ── fetchAllSingleProduct ──────────────────────────────────────
  const fetchAllSingleProduct = () => {
    const formData = new FormData();
    formData.append("id", id);
    axios
      .post(`${baseUrl}/customer/equipment/equipementDetails`, formData, {
        headers: { "Content-type": "multipart/formData" },
      })
      .then((res) => {
        console.log(res.data);
        if (res.data.success == true) {
          setProduct(res.data.equipment);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchAllSingleProduct();
  }, []);

  useEffect(() => {
    const shouldOpenTalk = localStorage.getItem("openTalkNowAfterLogin");

    const customer = JSON.parse(localStorage.getItem("LoggedInCustomer"));

    if (shouldOpenTalk === "true" && customer && product) {
      localStorage.removeItem("openTalkNowAfterLogin");

      handleTalkNow();
    }
  }, [product]);

  useEffect(() => {
    const shouldOpenBooking = localStorage.getItem("openBookingAfterLogin");
    if (shouldOpenBooking === "true") {
      setShowBookingModal(true);
      localStorage.removeItem("openBookingAfterLogin");
    }
  }, []);

  if (!product) {
    return <h1>Loading...</h1>;
  }

  const availableRates = getAvailableRates(product);

  // ── renderStars ────────────────────────────────────────────────
  const renderStars = (rating = 0) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={`full-${i}`} className="star-filled" />);
    }
    if (hasHalfStar) {
      stars.push(<FaStarHalfAlt key="half" className="star-filled" />);
    }
    const emptyStars = 5 - Math.ceil(rating);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<FaRegStar key={`empty-${i}`} className="star-empty" />);
    }
    return stars;
  };

  const handleShopClick = () => navigate(`/shop/${shop.id}`);

  const handleContact = () => {
    window.location.href = `tel:${shop.phone}`;
  };

  // ── handleTalkNow ──────────────────────────────────────────────
  const handleTalkNow = () => {
    const savedCustomer = JSON.parse(localStorage.getItem("LoggedInCustomer"));

    // ── Login nahi hai ─────────────────────────────────────────
    if (!savedCustomer || !savedCustomer.id) {
      localStorage.setItem("redirectAfterLogin", window.location.pathname);

      localStorage.setItem("openTalkNowAfterLogin", "true");

      navigate("/auth");
      return;
    }

    // ── Login hai — check conversation ────────────────────────
    const formData = new FormData();
    formData.append("srcustomer_id", savedCustomer.id);
    formData.append("srrentaladmin_id", product.srrentaladmin_id);
    formData.append("type", "general");

    axios
      .post(`${baseUrl}/customer/conversations/checkConversation`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((res) => {
        if (res.data.exists === true) {
          navigate("/user/messages", {
            state: { openConversationId: res.data.conversation.id },
          });
        } else {
          navigate(`/equipment/${product.id}/chat`, {
            state: {
              equipment: {
                id: product.id,
                name: product.equipmentname,
                rates: availableRates,
                image: typeof product.image === "string" ? product.image : null,
                available: product.status === "available",
                shopName: shop.name,
                shopId: shop.id,
                location: shop.location,
                srrentaladmin_id: product.srrentaladmin_id,
              },
              shop: {
                id: product.srrentaladmin_id,
                name: shop.name,
              },
            },
          });
        }
      })
      .catch((err) => {
        console.log("Error checking conversation:", err);
        navigate(`/equipment/${product.id}/chat`, {
          state: {
            equipment: {
              id: product.id,
              name: product.equipmentname,
              rates: availableRates,
              image: typeof product.image === "string" ? product.image : null,
              available: product.status === "available",
              shopName: shop.name,
              shopId: shop.id,
              location: shop.location,
              srrentaladmin_id: product.srrentaladmin_id,
            },
            shop: {
              id: product.srrentaladmin_id,
              name: shop.name,
            },
          },
        });
      });
  };

  // ── handleBookingNow ───────────────────────────────────────────
  const handleBookingNow = () => {
    const token = localStorage.getItem("authToken");
    const customer = JSON.parse(localStorage.getItem("LoggedInCustomer"));

    if (!token || !customer) {
      localStorage.setItem("redirectAfterLogin", window.location.pathname);
      localStorage.setItem("openBookingAfterLogin", "true");
      navigate("/auth");
      return;
    }
    setShowBookingModal(true);
  };

  const bookingEquipmentData = {
    equipment: {
      id: product.id,
      name: product.equipmentname,
      srrentaladmin_id: product.srrentaladmin_id,
      rate_per_hour: product.rate_per_hour,
      rate_per_day: product.rate_per_day,
      rate_per_acre: product.rate_per_acre,
      image: typeof product.image === "string" ? product.image : null,
      available: product.status === "available",
      shopName: shop.name,
      shopId: shop.id,
      location: shop.location,
      category: product.category_id,
      condition: "Maintained",
    },
    owner: shop.name,
  };

  return (
    <>
      <MyNavbar />
      <div className="pdp-page">
        <Container>
          {/* Back Button */}
          <Button
            variant="link"
            className="pdp-back-button"
            onClick={() => navigate(`/shop/${shop.id}`)}
          >
            <FaArrowLeft /> Back to Shop
          </Button>

          <Row className="pdp-detail-row">
            <Col lg={5} md={6}>
              <div className="pdp-image-section">
                <div className="pdp-main-image">
                  <img
                    src={`${baseUrlForFile}/${product.image}`}
                    alt={product.equipmentname}
                    onError={(e) => {
                      e.target.src = "/images/default-equipment.png";
                    }}
                  />
                  <span
                    className={`pdp-availability-badge ${product.status.toLowerCase()}`}
                  >
                    {product.status}
                  </span>
                </div>
              </div>
            </Col>

            <Col lg={7} md={6}>
              <div className="pdp-info-section">
                <span className="pdp-category-badge-top"> 
                  {product.category?.name}
                </span>
                {product.category?.equipment_type && (
                  <span className="pdp-equipmenttype-badge">
                    {product.category.equipment_type === "implement" ? "Implement" : "Self-Powered"}
                  </span>
                )}
                <h1 className="pdp-title">{product.equipmentname}</h1>

                <div className="pdp-rating-display">
                  <div className="pdp-stars">
                    {renderStars(product.rating || 0)}
                  </div>
                  <span className="pdp-rating-value">
                    ({product.reviewCount || 0})
                  </span>
                </div>

                <div className="pdp-about-section">
                  <h3 className="pdp-section-heading">About</h3>
                  <p className="pdp-section-text">{product.about}</p>
                </div>

                <div className="pdp-specs-section">
                  <h3 className="pdp-section-heading">Specifications</h3>
                  <div className="pdp-specs-badges">
                    {product.specification
                      ?.split(",")
                      .filter((spec) => spec.trim() !== "")
                      .map((spec, index) => (
                        <span key={index} className="pdp-spec-badge">
                          {spec.trim()}
                        </span>
                      ))}
                  </div>
                </div>

                <div className="pdp-details-grid">
                  <div className="pdp-detail-item">
                    <FaCalendarAlt className="pdp-detail-icon" />
                    <div className="pdp-detail-content">
                      <span className="pdp-detail-label">Rental Rate</span>
                      {availableRates.length > 0 ? (
                        <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                          {availableRates.map((r, i) => (
                            <span key={i} className="pdp-detail-value">
                              Rs. {r.value.toLocaleString("en-PK")} / {r.unit}
                            </span>
                          ))}
                        </div>
                      ) : (
                        <span className="pdp-detail-value">Price on request</span>
                      )}
                    </div>
                  </div>

                  <div className="pdp-detail-item">
                    <FaMapMarkerAlt className="pdp-detail-icon" />
                    <div className="pdp-detail-content">
                      <span className="pdp-detail-label">Location</span>
                      <span className="pdp-detail-value">{shop.location}</span>
                    </div>
                  </div>

                  <div
                    className="pdp-detail-item clickable"
                    onClick={handleShopClick}
                  >
                    <FaStore className="pdp-detail-icon" />
                    <div className="pdp-detail-content">
                      <span className="pdp-detail-label">Shop</span>
                      <span className="pdp-detail-value pdp-shop-link">
                        {shop.name}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="pdp-action-buttons">
                  {product.status?.toLowerCase() === "available" && (
                    <Button className="pdp-rent-button" onClick={handleTalkNow}>
                      Talk NOW
                    </Button>
                  )}
                  <Button
                    className="pdp-booking-button"
                    onClick={handleBookingNow}
                    disabled={product.status === "rented"}
                  >
                    <FaCalendarAlt style={{ marginRight: "8px" }} />
                    Booking Now
                  </Button>
                </div>

                <EquipmentBookingModal
                  show={showBookingModal}
                  onHide={() => setShowBookingModal(false)}
                  equipmentData={bookingEquipmentData}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default ProductDetailPage;